import { Descriptions } from 'antd';
import { FormatDate } from '../../../constants';
import { Link } from 'react-router-dom';

interface CaseInfoHeaderProps {
  isArchived?: boolean;
  data: CaseInfoHeaderFields;
  caseType: 'credentialVerification' | 'sendReport' | 'identityVerification';
}

export interface CaseInfoHeaderFields {
  applicant: {
    displayName: string;
    id: string;
  };
  submittedAt: string;
  lastActivityAt: string;
  expirationEligibleAt?: string;
  id: string;
}



export const CaseInfoHeader: React.FC<CaseInfoHeaderProps> = (props) => {
  const expirationLabel = (() => {
    if (!props.data?.expirationEligibleAt) return 'Case Expires';
    const daysLeft = Math.ceil((new Date(props.data.expirationEligibleAt).getTime() - Date.now()) / (1000 * 60 * 60 * 24));
    return daysLeft >= 0 ? `Case Expires (${daysLeft} days)` : 'Case Expires';
  })(); 

  return (
    <div>
      <Descriptions layout="vertical" column={6}>
        <Descriptions.Item label="Applicant">
          <Link to={`/staff/applicants/${props?.data?.applicant?.id}/applicant-details`}>
            {props?.data?.applicant?.displayName ?? ''}
          </Link>
        </Descriptions.Item>
        <Descriptions.Item label="Submission Date">{FormatDate(props?.data?.submittedAt)}</Descriptions.Item>
        <Descriptions.Item label="Last Activity">{FormatDate(props?.data?.lastActivityAt)}</Descriptions.Item>
        <Descriptions.Item 
          label={expirationLabel}>
          {props?.data?.expirationEligibleAt ? FormatDate(props?.data?.expirationEligibleAt) : 'N/A'}
        </Descriptions.Item>
        <Descriptions.Item label="Applicant ID">{props?.data?.applicant?.id ?? ''}</Descriptions.Item>
        <Descriptions.Item label="Case ID">{props?.data?.id ?? ''}</Descriptions.Item>
      </Descriptions>
    </div>
  );
};
